import { useState } from "react";
import { useSelector } from "react-redux";

export const usePermission = (permisos = []) => {
    const roles = useSelector((state) => state.auth.roles);
    const isAdmin = useSelector((state) => state.auth.isAdmin);

    return permisos.reduce((acc, permiso) => {
        ///Si el usuadio es administrador tiene acceso a todos los permiso de lo contrario se valida el permiso que tenga asignado en su roll correspondiente
        if (isAdmin)
            acc[permiso] = isAdmin;
        else
            acc[permiso] = roles.some(r => r.titulo.trim() === permiso.trim() && r.activo === true);

        return acc;
    }, {});
};

export const useInfoUser = () => {
    const user = useSelector((state) => state.auth);

    return {
        User: user.user,
        Company: user.company,
        Admin: user.AdminTae,
        CompanyId: user.CompanyId
    }
}